import { isAdminPhone } from '@/lib/adminPhone';
import { normalizeUsPhoneNumber } from '@/lib/phone';

export type PostAuthDestination = '/auth/portal-choice' | '/app/expenses';

export function getPostAuthDestination(
  phone: string | null | undefined,
): PostAuthDestination {
  const normalized = phone?.startsWith('+')
    ? phone.trim()
    : normalizeUsPhoneNumber(phone ?? '');
  return isAdminPhone(normalized) ? '/auth/portal-choice' : '/app/expenses';
}
